import React from "react";
import ModalShell from "./ModalShell";
import styles from "./Drawer.module.css";

// Right-hand panel over a dimmed page; Escape and a click outside close it.
export default function Drawer({ title, onClose, children }) {
  return (
    <ModalShell onClose={onClose} overlayClassName={styles.overlay}>
      <aside className={styles.drawer} role="dialog" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <header className={styles.header}>
          <h2>{title}</h2>
          <button type="button" className={styles.close} aria-label="Close" onClick={onClose}>×</button>
        </header>
        <div className={styles.body}>{children}</div>
      </aside>
    </ModalShell>
  );
}
